import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    arrow: {
        background: '#ffffffd6',
        opacity: 1,
        '&::before': {
            color: theme.colors.black,
        },

        '&:hover': {
            opacity: 1,
            background: theme.colors.white,
        },
    },
}))
